module.exports = __webpack_public_path__ + "img/x7.208662b3.jpg";